<template>
  <div class="content__body">
    <div class="content__title">
      <router-link :to="{ name: 'managers-create' }" class="link">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9" cy="9" r="9" fill="#2B93E7"/>
          <path
            d="M11.9694 9.67347H9.67347V11.9694C9.67347 12.2219 9.46684 12.4286 9.21429 12.4286C8.96173 12.4286 8.7551 12.2219 8.7551 11.9694V9.67347H6.45918C6.20663 9.67347 6 9.46684 6 9.21429C6 8.96173 6.20663 8.7551 6.45918 8.7551H8.7551V6.45918C8.7551 6.20663 8.96173 6 9.21429 6C9.46684 6 9.67347 6.20663 9.67347 6.45918V8.7551H11.9694C12.2219 8.7551 12.4286 8.96173 12.4286 9.21429C12.4286 9.46684 12.2219 9.67347 11.9694 9.67347Z"
            fill="white"/>
        </svg>
        <span>Добавить менеджера</span>
      </router-link>
    </div>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      ref="userListTable"
      class="table-default">
      <div slot="fio" slot-scope="props" class="table-default__left">
        {{ props.row.fio }}
      </div>
      <div slot="phone_number" slot-scope="props">
        {{ props.row.phone_number ? props.row.phone_number : '-' }}
      </div>
      <div slot="email" slot-scope="props">
        {{ props.row.email ? props.row.email : '-' }}
      </div>
      <div slot="expo_token" slot-scope="props">
        {{ props.row.expo_token === undefined || props.row.expo_token === null || props.row.expo_token === '' ? 'нет' : 'да' }}
      </div>
      <div slot="tooltip" slot-scope="props">
        <v-popover
          placement="left-start"
        >
          <button class="tooltip-target b3">
            <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 4C10.1046 4 11 3.10457 11 2C11 0.89543 10.1046 0 9 0C7.89543 0 7 0.89543 7 2C7 3.10457 7.89543 4 9 4Z" fill="#2B93E7"/>
              <path d="M16 4C17.1046 4 18 3.10457 18 2C18 0.89543 17.1046 0 16 0C14.8954 0 14 0.89543 14 2C14 3.10457 14.8954 4 16 4Z" fill="#2B93E7"/>
              <path d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z" fill="#2B93E7"/>
            </svg>
          </button>
          <template slot="popover">
            <ul class="tooltip__list">
              <li class="tooltip__item">
                <img src="@/assets/img/edit-icon.svg" alt="Edit icon">
                <router-link :to="{ name: 'managers-detail', params: { id: props.row.id } }" class="tooltip__btn">Редактировать</router-link>
              </li>
              <li class="tooltip__item">
                <img src="@/assets/img/trash-icon.svg" alt="Delete icon">
                <button @click="deleteItem(props.row.id)" class="tooltip__btn">Удалить</button>
              </li>
            </ul>
          </template>
        </v-popover>
      </div>
    </v-client-table>
  </div>
</template>

<script>
export default {
  name: 'ManagersList',
  data() {
    return {
      table: {
        items: [],
        columns: ['id', 'fio', 'phone_number', 'email', 'expo_token', 'tooltip'],
        options: {
          headings: {
            'id': 'ID',
            'fio': 'ФИО',
            'phone_number': 'Телефон',
            'email': 'Электронная почта',
            'expo_token': 'Токен',
            'tooltip': ''
          },
          pagination: { show: false },
          sortable: [],
          perPage: 999,
          texts: {
            filter: '',
            filterPlaceholder: 'Поиск по таблице',
            noResults: 'Нет подходящих записей',
            filterBy: '',
            loading: 'Загрузка',
            count: '',
            limit: 'Количество записей на странице:',
            page: 'Страница:'
          },
          rowClassCallback: row => 'table-default__row',
        },
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList () {
      this.$store.dispatch('usersMain/GET_MANAGERS')
        .then(response => {
          this.table.items = response.data
        })
        .catch(error => {
          this.$notify({
            type: 'warn',
            title: 'Внимание!',
            text: `Ошибка: ${ error.message }`
          })
        })
    },
    deleteItem(id) {
      this.$store.dispatch('usersMain/DELETE_MANAGER', id)
        .then(() => {
          document.body.click()
          this.getList()
          this.$notify({
            type: 'success',
            title: 'Успех!',
            text: 'Менеджер удален.'
          })
        })
        .catch(error => {
          this.$notify({
            type: 'warn',
            title: 'Внимание!',
            text: `Ошибка: ${ error.message }`
          })
        })
    }
  }
}
</script>
